/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';
import formatDate from '../formatDate';
import { getToggleAllDayState } from '../hourFilter';

export function reportsPaymentMethodsStart({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Payment Methods Start', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsPaymentMethodsExportData({
  outletIds,
  startDate,
  endDate,
}) {
  pushClevertapEvent('Report Payment Methods Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportsPaymentMethodsPerOutletExport({
  outletIds,
  startDate,
  endDate,
}) {
  pushClevertapEvent('Report Payment Methods Per Outlet Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
